import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.BUSCAR_SIGNATARIOS](context, idDocumento) {
		const { data } = await api.signatariosAtaApiClient.buscarSignatariosDocumento(idDocumento)
		return data
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.CONVIDAR_SIGNATARIOS](
		context,
		{ idDocumento, emailsSignatarios },
	) {
		return await api.signatariosAtaApiClient.convidarSignatariosProcessoDigital(idDocumento, emailsSignatarios)
	},

	async [actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.SIGNATARIOS.EXCLUIR](context, { idDocumento, emailsSignatarios }) {
		await api.signatariosAtaApiClient.excluirSignatariosProcessoDigital(idDocumento, emailsSignatarios)
	},

	async [actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.BUSCAR_ASSINATURAS_NAO_CONCLUIDAS](context, idAta) {
		const { data } = await api.signatariosAtaApiClient.buscarAssinaturasNaoConluidasDocumentoProcessoDigital(idAta)
		return data
	},
}
